<template>
    <div>
        <date-picker
            v-model="current"
            :type="type"
            :valueType="valueType"
            :lang="$i18n.locale"
            :range="isRange"
            :shortcuts="isShortcuts"
            :firstDayOfWeek="1"
            :format="format"
            :placeholder="placeholder"
            :notBefore="notBefore"
            :notAfter="notAfter"
            :inputClass="'form-control' + (isInvalid ? ' is-invalid' : '')"
            :inputAttr="{ 'aria-invalid': 'input-required-feedback' }"
            :disabled="disabled"
            :timePickerOptions="timePickerOptions"
            class="w-100"
        />
        <b-form-invalid-feedback
            id="input-required-feedback"
            :style="{ display: isInvalid ? 'block' : 'none' }"
        >
            {{ $t('custom.dataPicker.feedback') }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';

export default {
    name: 'CustomDatePicker',

    components: { DatePicker },

    props: {
        value: {
            type: [Array, Date, String, Object],
            'default': null,
        },

        placeholder: {
            type: String,
            'default': '',
        },

        format: {
            type: String,
            'default': 'DD.MM.YYYY',
        },

        valueType: {
            type: String,
            'default': 'date',
        },

        type: {
            type: String,
            'default': 'date',
        },

        timePickerOptions: {
            type: Object,
            'default': null,
        },

        isInvalid: {
            type: Boolean,
            'default': false,
        },

        notBefore: {
            type: [String, Date, Number],
            'default': '',
        },

        notAfter: {
            type: [String, Date, Number],
            'default': '',
        },

        disabled: {
            type: Boolean,
            'default': false,
        },

        isRange: {
            type: Boolean,
            'default': false,
        },

        isShortcuts: {
            type: Boolean,
            'default': false,
        },
    },

    data() {
        return {
            current: this.value,
        };
    },

    watch: {
        current: function() {
            this.$emit('input', this.current);
        },

        value: function() {
            this.current = this.value;
        },
    },
};
</script>